import api from "api";

export const fetchBranch = () => api.get("/sucursal");
export const createBranch = (data) => api.post("/sucursal", data);
